// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* --- Modal Dialog & Backdrop --- */
dialog.modal-window {
  width: 100%;
  max-width: 576px;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 12px;
  box-shadow: 0px 12px 32px rgba(11, 26, 125, 0.06);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: none;
  margin: auto;
  padding: 0;
}

dialog.modal-window:not([open]) {
    display: none !important;
}

dialog.modal-window::backdrop {
  background-color: rgba(26, 28, 29, 0.2);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

/* Hide the dialog completely when not open (browser default, but enforced here) */
/* dialog:not([open]) {
  display: none;
} */

.modal-header {
  padding: 32px 32px 16px 32px;
}

.modal-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #0b1a7d;
  letter-spacing: -0.025em;
}

.modal-subtitle {
  font-size: 0.875rem;
  color: #454652;
  margin-top: 4px;
}

.modal-form {
  padding: 0 32px 32px 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* --- Form Elements --- */
.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-label {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #454652;
  margin-left: 4px;
}

.input-wrapper {
  position: relative;
  display: flex;
}

.form-control {
  width: 100%;
  background-color: #f3f3f5;
  border: none;
  border-radius: 8px;
  padding: 16px;
  color: #1a1c1d;
  font-family: inherit;
  font-size: 1rem;
  outline: none;
  transition:
    box-shadow 0.2s,
    background-color 0.2s;
}

.form-control:focus {
  box-shadow: 0 0 0 2px rgba(11, 26, 125, 0.3);
}

.form-control::placeholder {
  color: #767683;
}

textarea.form-control {
  resize: none;
  padding-bottom: 24px;
}

/* Grouped Inputs (Grid) */
.input-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

select.form-control,
input[type="date"].form-control {
  -webkit-appearance: none;
  appearance: none;
  padding: 12px 16px 12px 16px;
}

.input-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #767683;
  font-size: 1.125rem;
  pointer-events: none;
}

/* Priority Toggle Buttons
.priority-toggle {
  display: flex;
  gap: 8px;
  padding: 4px;
  background-color: #f3f3f5;
  border-radius: 12px;
}

.priority-btn {
  flex: 1;
  padding: 8px 12px;
  border: none;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
  transition: all 0.2s;
  background-color: transparent;
  color: #454652;
}

.priority-btn:hover:not(.active) {
  background-color: #ffffff;
  color: #0b1a7d;
}

.priority-btn.active {
  background-color: #beebe7;
  color: #224e4b;
}

.priority-btn.white-bg {
  background-color: #ffffff;
} */

/* Priority Toggle Base Styles */
.priority-toggle {
  display: flex;
  gap: 8px;
  padding: 4px;
  background-color: #f3f3f5;
  border-radius: 12px;
}

/* 1. Visually hide the actual radio circles */
.visually-hidden {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;
}

/* 2. The Label (Acts as the clickable button) */
.priority-btn {
  flex: 1;
  padding: 8px 12px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
  text-align: center;
  transition: all 0.2s;
  background-color: transparent;
  color: #454652;
  
  /* Prevents text highlighting when clicking fast */
  user-select: none; 
}

/* 3. Hover state ONLY for buttons that are NOT checked */
input[type="radio"]:not(:checked) + .priority-btn:hover {
  background-color: #ffffff;
  color: #0b1a7d;
}

/* 4. Active (Checked) state */
input[type="radio"]:checked + .priority-btn {
  background-color: #beebe7;
  color: #224e4b;
}

/* --- Actions --- */
.form-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  padding-top: 16px;
}

.btn-cancel {
  background: none;
  border: none;
  padding: 12px 24px;
  font-size: 0.875rem;
  font-weight: 700;
  color: #454652;
  cursor: pointer;
  font-family: inherit;
  transition: color 0.2s;
}

.btn-cancel:hover {
  color: #0b1a7d;
}

.btn-submit {
  background: linear-gradient(to right, #0b1a7d, #283593);
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 12px 32px;
  font-size: 0.875rem;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
  box-shadow: 0 10px 15px -3px rgba(11, 26, 125, 0.2);
  transition: transform 0.2s;
}

.btn-submit:active {
  transform: scale(0.98);
}
`, "",{"version":3,"sources":["webpack://./src/styles/newTaskDialog.css"],"names":[],"mappings":";AACA,oCAAoC;AACpC;EACE,WAAW;EACX,gBAAgB;EAChB,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,iDAAiD;EACjD,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,UAAU;AACZ;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;EACE,uCAAuC;EACvC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA,kFAAkF;AAClF;;GAEG;;AAEH;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,aAAa;EACb;;yBAEuB;AACzB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,wBAAwB;EACxB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAmCG;;AAEH,gCAAgC;AAChC;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,oBAAoB;AACtB;;AAEA,gDAAgD;AAChD;EACE,OAAO;EACP,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,6BAA6B;EAC7B,cAAc;;EAEd,kDAAkD;EAClD,iBAAiB;AACnB;;AAEA,yDAAyD;AACzD;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uDAAuD;EACvD,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mDAAmD;EACnD,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["\n/* --- Modal Dialog & Backdrop --- */\ndialog.modal-window {\n  width: 100%;\n  max-width: 576px;\n  background: rgba(255, 255, 255, 0.85);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border-radius: 12px;\n  box-shadow: 0px 12px 32px rgba(11, 26, 125, 0.06);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border: none;\n  margin: auto;\n  padding: 0;\n}\n\ndialog.modal-window:not([open]) {\n    display: none !important;\n}\n\ndialog.modal-window::backdrop {\n  background-color: rgba(26, 28, 29, 0.2);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n}\n\n/* Hide the dialog completely when not open (browser default, but enforced here) */\n/* dialog:not([open]) {\n  display: none;\n} */\n\n.modal-header {\n  padding: 32px 32px 16px 32px;\n}\n\n.modal-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #0b1a7d;\n  letter-spacing: -0.025em;\n}\n\n.modal-subtitle {\n  font-size: 0.875rem;\n  color: #454652;\n  margin-top: 4px;\n}\n\n.modal-form {\n  padding: 0 32px 32px 32px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n/* --- Form Elements --- */\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-label {\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: #454652;\n  margin-left: 4px;\n}\n\n.input-wrapper {\n  position: relative;\n  display: flex;\n}\n\n.form-control {\n  width: 100%;\n  background-color: #f3f3f5;\n  border: none;\n  border-radius: 8px;\n  padding: 16px;\n  color: #1a1c1d;\n  font-family: inherit;\n  font-size: 1rem;\n  outline: none;\n  transition:\n    box-shadow 0.2s,\n    background-color 0.2s;\n}\n\n.form-control:focus {\n  box-shadow: 0 0 0 2px rgba(11, 26, 125, 0.3);\n}\n\n.form-control::placeholder {\n  color: #767683;\n}\n\ntextarea.form-control {\n  resize: none;\n  padding-bottom: 24px;\n}\n\n/* Grouped Inputs (Grid) */\n.input-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\nselect.form-control,\ninput[type=\"date\"].form-control {\n  -webkit-appearance: none;\n  appearance: none;\n  padding: 12px 16px 12px 16px;\n}\n\n.input-icon {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #767683;\n  font-size: 1.125rem;\n  pointer-events: none;\n}\n\n/* Priority Toggle Buttons\n.priority-toggle {\n  display: flex;\n  gap: 8px;\n  padding: 4px;\n  background-color: #f3f3f5;\n  border-radius: 12px;\n}\n\n.priority-btn {\n  flex: 1;\n  padding: 8px 12px;\n  border: none;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  font-family: inherit;\n  cursor: pointer;\n  transition: all 0.2s;\n  background-color: transparent;\n  color: #454652;\n}\n\n.priority-btn:hover:not(.active) {\n  background-color: #ffffff;\n  color: #0b1a7d;\n}\n\n.priority-btn.active {\n  background-color: #beebe7;\n  color: #224e4b;\n}\n\n.priority-btn.white-bg {\n  background-color: #ffffff;\n} */\n\n/* Priority Toggle Base Styles */\n.priority-toggle {\n  display: flex;\n  gap: 8px;\n  padding: 4px;\n  background-color: #f3f3f5;\n  border-radius: 12px;\n}\n\n/* 1. Visually hide the actual radio circles */\n.visually-hidden {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n  pointer-events: none;\n}\n\n/* 2. The Label (Acts as the clickable button) */\n.priority-btn {\n  flex: 1;\n  padding: 8px 12px;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  font-family: inherit;\n  cursor: pointer;\n  text-align: center;\n  transition: all 0.2s;\n  background-color: transparent;\n  color: #454652;\n  \n  /* Prevents text highlighting when clicking fast */\n  user-select: none; \n}\n\n/* 3. Hover state ONLY for buttons that are NOT checked */\ninput[type=\"radio\"]:not(:checked) + .priority-btn:hover {\n  background-color: #ffffff;\n  color: #0b1a7d;\n}\n\n/* 4. Active (Checked) state */\ninput[type=\"radio\"]:checked + .priority-btn {\n  background-color: #beebe7;\n  color: #224e4b;\n}\n\n/* --- Actions --- */\n.form-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 16px;\n  padding-top: 16px;\n}\n\n.btn-cancel {\n  background: none;\n  border: none;\n  padding: 12px 24px;\n  font-size: 0.875rem;\n  font-weight: 700;\n  color: #454652;\n  cursor: pointer;\n  font-family: inherit;\n  transition: color 0.2s;\n}\n\n.btn-cancel:hover {\n  color: #0b1a7d;\n}\n\n.btn-submit {\n  background: linear-gradient(to right, #0b1a7d, #283593);\n  color: #ffffff;\n  border: none;\n  border-radius: 8px;\n  padding: 12px 32px;\n  font-size: 0.875rem;\n  font-weight: 700;\n  font-family: inherit;\n  cursor: pointer;\n  box-shadow: 0 10px 15px -3px rgba(11, 26, 125, 0.2);\n  transition: transform 0.2s;\n}\n\n.btn-submit:active {\n  transform: scale(0.98);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
